
module.exports = [
  'M2 2 L10 2 L10 10 L2 10z M12 2 L20 2 L20 10 L12 10z M22 2 L30 2 L30 10 L22 10z M2 12 L10 12 L10 20 L2 20z M12 12 L20 12 L20 20 L12 20z M22 12 L30 12 L30 20 L22 20z M2 22 L10 22 L10 30 L2 30z M12 22 L20 22 L20 30 L12 30z M22 22 L30 22 L30 30 L22 30z'
].join(' ')




//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/geomicons-open/src/paths/grid.js
// module id = 328
// module chunks = 6